// extracted by css-extract-rspack-plugin
export default {"hint":"PreparingColumn__hint--FoDXU"};